import React, { useState } from "react";

import StateServices from "services/StateServices";
import StatesTable from "components/states/statesTable";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import StateDrawer from "components/drawer/StateDrawer";
import { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import TableLoading from "components/preloader/TableLoading";
import Somethingwentwrong from "pages/Somethingwentwrong";
import NotFound from "components/table/NotFound"; // Import NotFound component

import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import {
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
  Card,
  CardBody,
  Input,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";

import ExportData from "components/common/ExportData";
const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const State = () => {
  const { toggleDrawer } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const [status] = useState("");
  const { data, loading } = useAsync(() => StateServices.getAllState());
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array
  // const hideView = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "staff" && perm.view === 1
  // );
  // const hideDelete = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "staff" && perm.delete === 1
  // );
  // const hideEdit = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "staff" && perm.edit === 1
  // );
  // const hideAdd = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "staff" && perm.add === 1
  // );
  // const hideExport = adminInfo?.permission?.some(
  //   (perm) => perm.id_tab === "staff" && perm.export === 1
  // );
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "state" && perm.view === 1
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "state" && perm.delete === 1
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "state" && perm.edit === 1
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "state" && perm.add === 1
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "state" && perm.export === 1
      );

  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  // Contains the column headers and table data in the required format for CSV

  const csvData = [
    ["State", "Country"],
    ...safeData.map(({ country_name, name }) => [country_name, name]),
  ];

  // const columns = [
  //   { name: "SL. No.", selector: (row) => row.id, cell },

  //   {
  //     name: "State",
  //     selector: (row) => row.name,
  //     sortable: true,
  //   },
  //   {
  //     name: "Country",
  //     selector: (row) => row.country_name,
  //     sortable: true,
  //   },
  //   {
  //     name: "Actions",
  //     cell: (row) => (
  //       <EditDeleteButton
  //         id={row.id_state}
  //         State={row}
  //         isSubmitting={isSubmitting}
  //         handleUpdate={handleUpdate}
  //         handleModalOpen={handleModalOpen}
  //         hideDelete={hideDelete}
  //         hideEdit={hideEdit}
  //       />
  //     ),
  //   },
  // ];

  const filteredData = safeData.filter(
    (item) =>
      (item.name !== null &&
        item.name.toLowerCase().includes(searchText.toLowerCase())) ||
      (item.country_name !== null &&
        item.country_name.toLowerCase().includes(searchText.toLowerCase()))
  );

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            <StateDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    value={searchText}
                    autoComplete="off"
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search"
                  />
                </div>

                {hideAdd && (
                  <div className="w-56">
                    <Button
                      onClick={toggleDrawer}
                      className="w-full rounded-md h-10"
                    >
                      <span className="mr-3">
                        <FiPlus />
                      </span>
                      Add State
                    </Button>
                  </div>
                )}

                {hideExport && (
                  <div className="items-center">
                    <ExportData
                      title="State"
                      exportData={csvData}
                      filename="State List.csv"
                    />
                  </div>
                )}
              </form>
            </CardBody>
          </Card>

          <div className="data-table-container">
            {loading ? (
              // Display a loading spinner or message while data is being fetched
              <TableLoading row={12} col={6} width={190} height={20} />
            ) : status === false || status === undefined ? (
              <Somethingwentwrong title="Something went wrong, please try again later." />
            ) : safeData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">State</TableCell>
                      <TableCell className="text-center">Country</TableCell>
                      <TableCell className="text-center">Actions</TableCell>
                    </tr>
                  </TableHeader>

                  <StatesTable
                    title={data.name}
                    id={data.id_state}
                    statesdata={filteredData}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no States." />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default State;
